import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";
import MainState from "./context/main/mainState";

ReactDOM.render(<MainState><App /></MainState>, document.getElementById("root"));
